"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FlagManager_flags;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagManager = void 0;
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const viewer_shared_types_1 = require("@shapediver/viewer.shared.types");
class FlagManager {
    constructor(_renderingEngine, props) {
        this._renderingEngine = _renderingEngine;
        this._eventEngine = viewer_shared_services_1.EventEngine.instance;
        this._stateEngine = viewer_shared_services_1.StateEngine.instance;
        this._uuidGenerator = viewer_shared_services_1.UuidGenerator.instance;
        _FlagManager_flags.set(this, {
            [viewer_shared_types_1.FLAG_TYPE.CAMERA_FREEZE]: [],
            [viewer_shared_types_1.FLAG_TYPE.CONTINUOUS_RENDERING]: [],
            [viewer_shared_types_1.FLAG_TYPE.CONTINUOUS_SHADOW_MAP_UPDATE]: [],
            [viewer_shared_types_1.FLAG_TYPE.SUSPEND_SCENE_UPDATES]: [],
        });
        for (const token in props.flags) {
            this.addFlag(props.flags[token], token);
        }
    }
    addFlag(flag, inputToken) {
        var _a;
        const token = inputToken || this._uuidGenerator.create();
        if (flag === viewer_shared_types_1.FLAG_TYPE.BUSY_MODE) {
            (_a = this._stateEngine.viewportEngines[this._renderingEngine.id]) === null || _a === void 0 ? void 0 : _a.busy.push(token);
        }
        else {
            __classPrivateFieldGet(this, _FlagManager_flags, "f")[flag].push(token);
        }
        this.evaluateFlagState();
        return token;
    }
    evaluateFlagState() {
        // busy
        {
            const currentBusyState = this._renderingEngine.busy;
            if (this._stateEngine.viewportEngines[this._renderingEngine.id] &&
                this._stateEngine.viewportEngines[this._renderingEngine.id]
                    .busy.length > 0) {
                if (!currentBusyState) {
                    this._renderingEngine.busy = true;
                    this._renderingEngine.renderingManager.render();
                    this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.VIEWPORT.BUSY_MODE_ON, { viewportId: this._renderingEngine.id });
                }
            }
            else {
                if (currentBusyState) {
                    this._renderingEngine.busy = false;
                    this._renderingEngine.renderingManager.render();
                    this._eventEngine.emitEvent(viewer_shared_services_1.EVENTTYPE.VIEWPORT.BUSY_MODE_OFF, { viewportId: this._renderingEngine.id });
                }
            }
        }
        // camera freeze
        {
            if (__classPrivateFieldGet(this, _FlagManager_flags, "f")[viewer_shared_types_1.FLAG_TYPE.CAMERA_FREEZE].length > 0) {
                this._renderingEngine.cameraEngine.deactivateCameraEvents();
            }
            else {
                this._renderingEngine.cameraEngine.activateCameraEvents();
            }
        }
        // continuous rendering
        {
            const currentContinuousRenderingState = this._renderingEngine.continuousRendering;
            if (__classPrivateFieldGet(this, _FlagManager_flags, "f")[viewer_shared_types_1.FLAG_TYPE.CONTINUOUS_RENDERING].length > 0) {
                if (!currentContinuousRenderingState) {
                    this._renderingEngine.continuousRendering = true;
                    this._renderingEngine.renderingManager.render();
                }
            }
            else {
                if (currentContinuousRenderingState) {
                    this._renderingEngine.continuousRendering = false;
                }
            }
        }
        // continuous shadow map update
        {
            const currentShadowMapUpdateState = this._renderingEngine.continuousShadowMapUpdate;
            if (__classPrivateFieldGet(this, _FlagManager_flags, "f")[viewer_shared_types_1.FLAG_TYPE.CONTINUOUS_SHADOW_MAP_UPDATE].length > 0) {
                if (!currentShadowMapUpdateState) {
                    this._renderingEngine.continuousShadowMapUpdate = true;
                    this._renderingEngine.renderingManager.render();
                }
            }
            else {
                if (currentShadowMapUpdateState) {
                    this._renderingEngine.continuousShadowMapUpdate = false;
                }
            }
        }
        // suspend scene updates
        {
            const currentSuspendSceneUpdatesState = this._renderingEngine.suspendSceneUpdates;
            if (currentSuspendSceneUpdatesState) {
                if (__classPrivateFieldGet(this, _FlagManager_flags, "f")[viewer_shared_types_1.FLAG_TYPE.SUSPEND_SCENE_UPDATES].length === 0) {
                    this._renderingEngine.suspendSceneUpdates = false;
                    this._renderingEngine.update("suspendSceneUpdates: false");
                    this._renderingEngine.renderingManager.render();
                }
            }
            else {
                if (__classPrivateFieldGet(this, _FlagManager_flags, "f")[viewer_shared_types_1.FLAG_TYPE.SUSPEND_SCENE_UPDATES].length > 0) {
                    this._renderingEngine.suspendSceneUpdates = true;
                }
            }
        }
    }
    init() { }
    removeFlag(token) {
        let success = false;
        const Flags = Object.values(viewer_shared_types_1.FLAG_TYPE);
        for (const f of Flags) {
            if (f === viewer_shared_types_1.FLAG_TYPE.BUSY_MODE) {
                if (this._stateEngine.viewportEngines[this._renderingEngine.id] &&
                    this._stateEngine.viewportEngines[this._renderingEngine.id].busy.includes(token)) {
                    this._stateEngine.viewportEngines[this._renderingEngine.id].busy.splice(this._stateEngine.viewportEngines[this._renderingEngine.id].busy.indexOf(token), 1);
                    success = true;
                    break;
                }
            }
            else {
                if (__classPrivateFieldGet(this, _FlagManager_flags, "f")[f].includes(token)) {
                    __classPrivateFieldGet(this, _FlagManager_flags, "f")[f].splice(__classPrivateFieldGet(this, _FlagManager_flags, "f")[f].indexOf(token), 1);
                    success = true;
                    break;
                }
            }
        }
        this.evaluateFlagState();
        return success;
    }
}
exports.FlagManager = FlagManager;
_FlagManager_flags = new WeakMap();
//# sourceMappingURL=FlagManager.js.map